import React from 'react'
import ReactDOM from 'react-dom/client'
import './translations/i18n'
import '@/theme.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/query-client.ts'
import App from './app'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</React.StrictMode>
)
